import React, {useEffect, useState} from 'react';
import CarouselWidgetHome from './CarouselWidgetHome';
import sAction from 'sAction';
// import moment from 'moment';

function DashboardWidget() {
    const [backgroundUrl, setBackgroundUrl] = useState('img/dashboard-background.png');
    const [slides, setSlides] = useState([]);

    useEffect(() => {
        sAction.rest.post('getWidgetCarrousel', {}, function(resp) {
            if (resp.status) {
                const slides = [];
                resp.message.data?.carrousel.forEach((item, index) => {
                    slides.push({
                        id: index,
                        title: item.headline,
                        text: item.description,
                        button: item.button_label,
                        btnLink: item.url,
                    });
                });

                const widgetBackground = resp.message.data?.background?.pic;
                if (widgetBackground && widgetBackground.length > 0) {
                    setBackgroundUrl(widgetBackground);
                }
                setSlides(slides);
            }
        }, false);
    }, []);


    return (<>
        <div className="dashboardWidget" style={{backgroundImage: `url("${backgroundUrl}")`}}>
            <div className="dashboardCarouselWidgetWrapper">
                <CarouselWidgetHome slides={slides} />
            </div>
        </div>
    </>);
}
export default DashboardWidget;
